import { commonStrings } from './index'
export default class {
  constructor() {
    this.errors = undefined
    this.seTexts = undefined
    this.debug = /debug$/.test(window.location.href)
  }

  getInternalText = (obj, fullPropName, args, returnVal) => {
    if (args.length === 0 || !obj)
      return returnVal

    const prop = args[0]
    if (obj.hasOwnProperty && !obj.hasOwnProperty(prop))
      return returnVal

    if (obj[prop] === null)
      return `[${fullPropName}]`
    if (typeof obj[prop] === 'string')
      return obj[prop]

    return this.getInternalText(obj[prop], fullPropName, args.slice(1), returnVal)
  }

  getText = (strings, args) => {
    if (this.debug)
      return `[${args.join('.')}]`

    let val = this.getInternalText(strings, args.join('.'), args, null)

    if (val === null)
      val = this.getInternalText(commonStrings, args.join('.'), args, 'TEXT SAKNAS')

    return val
  }

  findErrors = (strings, propName) => {
    for (const prop in strings) {
      const val = strings[prop]
      const fullPropName = propName.length === 0 ? prop : propName + "." + prop
      const seText = this.getInternalText(this.seTexts, fullPropName, fullPropName.split('.'))
      if (val === null) {
        this.errors.push({ prop: fullPropName, seText: seText, empty: false })
      }
      else if (typeof val === 'string' && val.length === 0)
        this.errors.push({ prop: fullPropName, seText: seText, empty: true })
      else if (typeof val !== 'string')
        this.findErrors(val, fullPropName)
    }
  }

  parse = (strings, seTexts) => {
    if (!this.debug)
      return null

    if (this.error === undefined) {
      this.errors = []
      this.seTexts = seTexts
      this.findErrors(strings, "")
    }

    return this.errors.length > 0 ? this.errors : null
  }
}